import './AddOns.scss';
import Component from './AddOns.js';
export default Component;
